import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import GlobalContext from '@cinch/oxd-utils/context/src'
import { FEATURES, hasFeatureFlag } from '@cinch/oxd-utils/feature-flags/src'

const ContextProvider: React.FC<any> = ({ children }) => {
  const data = useStaticQuery(graphql`
    query ContextQuery {
      allTranslations {
        edges {
          node {
            footer {
              terms
              privacy
              about
              partner
            }
            navigation {
              buy
              help
              sell
              jargon
              guides
              partners {
                overview
                dealerships
              }
            }
            search {
              search
              placeholder
              placeholderSmall
              speechPlaceholder
              byVoice
              showSearch
              hideSearch
            }
            authModal {
              title
              shortlist
              recommendations
              compare
              features
            }
            ourCommitmentModule {
              title
              buttonCta
              bullet1
              bullet2
              bullet3
              bullet4
            }
            deliveryModule {
              title
              bullet1
              bullet2
              bullet3
              bullet4
              bullet5
              bullet6
              buyNow
            }
          }
        }
      }
      homeReviews {
        reviews {
          make
          makeDisplay
          model
          modelDisplay
        }
      }
      prismic {
        allArticles(first: 5, sortBy: meta_lastPublicationDate_DESC) {
          edges {
            node {
              _meta {
                uid
                firstPublicationDate
              }
              lead_paragraph
              title
              main_image
            }
          }
        }
      }
    }
  `)

  const {
    footer,
    navigation,
    search,
    authModal,
    ourCommitmentModule,
    deliveryModule,
  } = data.allTranslations.edges[0].node
  const { reviews } = data.homeReviews
  const articles = data.prismic.allArticles.edges

  const footerColumns = [
    {
      title: 'Quick search',
      items: [
        { title: 'Browse cars', url: '/find-vehicle' },
        { title: 'Audi cars', url: '/find-vehicle?make=AUDI' },
        { title: 'BMW cars', url: '/find-vehicle?make=BMW' },
        { title: 'Ford cars', url: '/find-vehicle?make=FORD' },
        { title: 'All makes', url: '/cars' },
      ],
    },
    {
      title: 'Featured Articles',
      items: articles.map(({ node }: any) => ({
        title: node.title,
        url: `/post/${node._meta.uid}`,
      })),
    },
    {
      title: 'Featured Cars',
      items: reviews.map(({ make, makeDisplay, model, modelDisplay }: any) => ({
        title: `${makeDisplay} ${modelDisplay}`,
        url: `/find-vehicle?make=${make}&selectedModel=${model}`,
      })),
    },
    {
      title: 'cinch',
      items: [
        {
          title: 'About',
          url: '/about-us',
        },
        {
          title: 'Terms',
          url: '/terms-and-conditions',
        },
        {
          title: 'Privacy',
          url: '/privacy',
        },
        {
          title: 'Partners',
          url: '/partners',
        },
        hasFeatureFlag(FEATURES.CAMBRIDGE)
          ? {
              title: 'Support',
              url: '/support',
            }
          : {
              title: 'Profile',
              url: '/my-profile',
            },
      ],
    },
  ]

  const context: Cinch.Context = {
    footer,
    footerColumns,
    navigation,
    search,
    authModal,
    ourCommitmentModule,
    deliveryModule,
  }

  return <GlobalContext.Provider value={context}>{children}</GlobalContext.Provider>
}

export default ContextProvider
